import { render, staticRenderFns } from "./ShipperListPage.vue?vue&type=template&id=f49ae79c&scoped=true&"
import script from "./ShipperListPage.vue?vue&type=script&lang=js&"
export * from "./ShipperListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49ae79c",
  null
  
)

export default component.exports